import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function h({
  size: t = "small",
  accessibilityTitle: l = "glyph premium health solid",
  className: a,
  "data-testid": m,
  fill: s,
  stroke: L
}) {
  const i = () => o(a, r["ride-glyph"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: i(), "data-testid": m }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: s || "#03050F",
      stroke: L || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    l && /* @__PURE__ */ e.createElement("title", null, l),
    /* @__PURE__ */ e.createElement("path", { d: "M16 3.87988L4.89001 9.43988L6.34001 18.1699C6.81001 20.9999 8.47001 23.4899 10.9 25.0099L15.99 28.1899L21.08 25.0099C23.51 23.4899 25.17 20.9999 25.64 18.1699L27.09 9.43988L16 3.87988ZM21.1 14.8899L19.14 16.7999C19.03 16.9099 18.97 17.0699 19 17.2199L19.46 19.9099C19.54 20.3699 19.06 20.7199 18.64 20.4999L16.21 19.2299C16.07 19.1599 15.9 19.1599 15.76 19.2299L13.33 20.4999C12.92 20.7199 12.44 20.3699 12.51 19.9099L12.97 17.2099C13 17.0499 12.95 16.8999 12.83 16.7899L10.87 14.8799C10.54 14.5499 10.72 13.9899 11.18 13.9199L13.89 13.5299C14.05 13.5099 14.18 13.4099 14.25 13.2699L15.46 10.8199C15.67 10.3999 16.26 10.3999 16.47 10.8199L17.68 13.2699C17.75 13.4099 17.88 13.5099 18.04 13.5299L20.75 13.9199C21.21 13.9899 21.4 14.5499 21.06 14.8799L21.1 14.8899Z" })
  ));
}
export {
  h as RideGlPremiumHealthSolid
};
